export const SEARCH_API = '/api/globalsearch/';

export const SEARCH_RESULT_TYPE: {[key: string]: string} = {
  startup: 'Startup',
  serviceprovider: 'Service provider',
  service: 'Service',
  event: 'Event',
}
